<div class="animated fadeIn">

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             
              <br/>
                <div class="row form-group" >
                    <div class="col col-md-12">
                        <div class="card border border-success">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-3">
                                        <strong class="card-title">Company Audit Search</strong>  
                                    </div>
                                    <div class="col col-md-3">
                                        <select name="companyId" id="companyId" class="form-control-sm form-control" [(ngModel)]="companyId">
                                            <option  value="">Select Company</option>
                                            <option value="{{pdetails.companyId}}" *ngFor="let pdetails of compData">{{pdetails.companyName}}</option>
                                        </select>
                                    </div>                                        
                                    <div class="col col-md-2">
                                        <button type="submit" class="btn btn-primary btn-sm" (click)="searchCompanyAudit(1)" >Search</button>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card-body" > 
                                <div class="row form-group">
                                    <div class="col col-md-6">
                                        <label for="userRole" class=" form-control-label">
                                            <strong>Insurer</strong>
                                        </label>
                                    </div>                                        
                                    <div class="col col-md-6">
                                        &nbsp;
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-6">
                                        <select name="companyId" id="companyId" class="form-control-sm form-control" [(ngModel)]="companyId">
                                            <option  value="">Select Company</option>
                                            <option value="{{pdetails.companyId}}" *ngFor="let pdetails of compData">{{pdetails.companyName}}</option>
                                        </select>
                                    </div>                                        
                                    <div class="col col-md-6">
                                        <button type="submit" class="btn btn-primary btn-sm" (click)="searchCompanyAudit(1)" >Search</button>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                                            <thead>
                                                <tr role="row">
                                                    <th>Insurer</th>
                                                    <th>User Email</th>
                                                    <th>Field</th>
                                                    <th>Previous Value</th>
                                                    <th>Modified Value</th>
                                                    <th>Modified By</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody> 
                                            <tr role="row" class="odd" *ngFor="let ld of uaData">
                                                <td>{{ ld.companyName }}</td>
                                                <td>{{ ld.userEmail }}</td>
                                                <td>{{ ld.fieldName }}</td>
                                                <td>{{ ld.prevValue }}</td>
                                                <td>{{ ld.presentValue }}</td>
                                                <td>{{ ld.modifiedByEmail }}</td>
                                                <td>{{ ld.createDate| date:'dd-MM-yyyy HH:mm:ss' }}</td>
                                            </tr> 
                                            
                                            
                                        </tbody>
                                        </table>
            </div>
        </div>
       <div class="row">
                                    <div class="col-sm-12 col-md-5">
                                        <div class="dataTables_info" id="bootstrap-data-table_info" role="status" aria-live="polite">Showing {{(curPage-1)*perPageRow+1}} to {{(curPage-1)*perPageRow+noOfRows}} of {{totalRows}}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-7">
                                        <div class="dataTables_paginate paging_simple_numbers" id="bootstrap-data-table_paginate">
                                            <ul class="pagination">
                                               <!-- <li class="paginate_button page-item previous disabled" id="bootstrap-data-table_previous" (click)="searchFile(curPage-1)" *ngIf="curPage==1">
                                                    <a  aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                                </li>-->
                                                
                                                <li class="paginate_button page-item {{item==curPage?'active':''}}" *ngFor="let item of pages; let i = index" (click)="searchCompanyAudit(item)">
                                                    <a  aria-controls="bootstrap-data-table"  class="page-link">{{item}}</a>
                                                </li>
                                                <!--<li class="paginate_button page-item next" id="bootstrap-data-table_next" (click)="searchFile(curPage-1)" >
                                                    <a  aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0" class="page-link">Next</a>
                                                </li>-->
                                            </ul>
                                        </div>
                                    </div>
                                </div>
    </div>


</div>
</div><!-- .animated -->

